<template>
  <div class="home-main">
    <div v-if="$store.state.totalresultstep != 3" class="header">
      <img src="img/planejar.svg" alt="planejar" class="planejar-img">
    </div>
    <div v-if="$store.state.totalresultstep == 3" style="height:200px; background-size: 100% 300%;" class="header">
      <img src="img/planejar.svg" alt="planejar" class="planejar-img">
    </div>
    <div style="margin: 0; flex-direction:column;" class="flex-centered"></div>

    <div class="view">
      <div style="align-items: flex-start; margin: 0;" class="flex-centered">
        <div v-if="$store.state.totalresultstep != 3" style="margin-right: 15px; max-width:250px; height:100%">
          <sidemenu ></sidemenu>
        </div>
        <div style="margin: 0; width:100%" class="flex-centered">
          <mainframe class="sidemenu" v-if="$store.state.step < 5"></mainframe>
          <resultframe class="sidemenu" v-if="$store.state.step >= 5"></resultframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidemenu from "../component/Menu/Sidemenu";
import mainframe from "../component/Menu/Mainframe";
import resultframe from "../component/Menu/Resultframe";
export default {
  data() {
    return {};
  },
  components: { sidemenu, mainframe, resultframe },
  methods: {},
  mounted() {},
  computed: {},
};
</script>

<style>
.sidemenu{
background: rgba(240,240,240,1);
background: -moz-linear-gradient(left, rgba(240,240,240,1) 0%, rgba(255,255,255,1) 3%, rgba(255,255,255,1) 49%, rgba(255,255,255,1) 100%);
background: -webkit-gradient(left top, right top, color-stop(0%, rgba(240,240,240,1)), color-stop(3%, rgba(255,255,255,1)), color-stop(49%, rgba(255,255,255,1)), color-stop(100%, rgba(255,255,255,1)));
background: -webkit-linear-gradient(left, rgba(240,240,240,1) 0%, rgba(255,255,255,1) 3%, rgba(255,255,255,1) 49%, rgba(255,255,255,1) 100%);
background: -o-linear-gradient(left, rgba(240,240,240,1) 0%, rgba(255,255,255,1) 3%, rgba(255,255,255,1) 49%, rgba(255,255,255,1) 100%);
background: -ms-linear-gradient(left, rgba(240,240,240,1) 0%, rgba(255,255,255,1) 3%, rgba(255,255,255,1) 49%, rgba(255,255,255,1) 100%);
background: linear-gradient(to right, rgba(240,240,240,1) 0%, rgba(255,255,255,1) 3%, rgba(255,255,255,1) 49%, rgba(255,255,255,1) 100%);
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f0f0f0', endColorstr='#ffffff', GradientType=1 );
}
.flex-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0 20px 0;
}
</style>